/**
 * Invoice – L'Invoice sidebar / menu
 */

export default {
  menuEinvoice: {
    lookUp: "Look up",
    documents: "documents",
    edocuments: "e-documents",
    customers: "customers",
    settings: "settings",
    integrations: "integrations",
  },
};
